import { render, staticRenderFns } from "./productInformationNew.vue?vue&type=template&id=01a3bf3a&scoped=true"
import script from "./productInformationNew.vue?vue&type=script&lang=js"
export * from "./productInformationNew.vue?vue&type=script&lang=js"
import style0 from "./productInformationNew.vue?vue&type=style&index=0&id=01a3bf3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a3bf3a",
  null
  
)

export default component.exports